module.exports = __webpack_public_path__ + "static/media/insta_white.faa4df75.png";